import Button from 'components/atoms/button/Button';
import { useElementFullyScrolled } from 'hooks';
import { CSSProperties, useEffect, useRef } from 'react';
import {
  IChildrenProp,
  IDiv,
  ILoadingProp,
} from 'types/components/components.interface';
import './ContainerContent.scss';

interface IContainerContentProps extends IChildrenProp, ILoadingProp, IDiv {
  onFullyScroll?: () => void;
}

const ContainerContent = ({
  children,
  className = '',
  loading,
  onFullyScroll,
  ...props
}: IContainerContentProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const { isFullyScrolled } = useElementFullyScrolled(ref);

  useEffect(() => {
    if (isFullyScrolled && onFullyScroll) {
      onFullyScroll();
    }
  }, [isFullyScrolled]);

  return (
    <div
      ref={ref}
      {...props}
      className={`container-content ${className} ${loading ? 'loading' : ''}`}
      style={
        {
          ...props.style,
          '--container-height': ref.current?.clientHeight,
        } as CSSProperties
      }>
      {children}
      <div className='container-content-loading'>
        <Button isLoading>
          {' '}
          <Button.Text text=' ' />
        </Button>
      </div>
    </div>
  );
};

export default ContainerContent;
